import React, { useEffect, useState } from 'react'
import {
  change,
  getFormValues,
  reduxForm,
  stopAsyncValidation,
  submit,
} from 'redux-form'
import {
  Checkbox,
  Form,
  FormGroup,
  Select,
  TextareaInput,
  TextInput,
} from '../../components/FormBuilder'
import useSize from '../../hooks/useSize'
import { Desktop, is } from '../../components/MediaQuery'
import { Trans, useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import {
  CallButton,
  MessageSendButton,
  TemplateSendButton,
} from '../Form/CreateReservation/TemplateSendButton'
import openModal, {
  closeTooltip,
  openTooltip,
} from '../../actions/Modals/openModal'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty, isEqual } from 'lodash'
import { FiInfo, FiSave } from 'react-icons/fi'
import { PermissionList, ScopeGroup, ScopeGroupPermissions } from './index'
import Tooltip from '../../components/Tooltip/Tooltip'
import Scrollbars from '../../components/Scrollbars/Scrollbars'
import { Null } from '../Template/Sidebar/Menu/SidebarContent'
import { ButtonsWrapper, SubmitButton } from '../../components/Form'
import { Dispatch } from 'redux'
import { shouldAsyncValidate } from '../BookingCalendar/Calendar/SetPriceModal/validate'
import { EmployeesAction } from '../../reducers/employees/actionNames'
import { fireToastError } from '../../actions/toasts/fireToast'
import {
  getEmailError,
  getEmployeeLoading,
} from '../../reducers/employees/selectors'
import { Title } from '../../components/FormBuilder/FormGroup/Title'
import Button from '../../components/Template/Button'
import styled from '../../theme'
import CloseModal from './CloseModal'
import { withRouter } from 'react-router'
import { driver, names } from '../../database/localStorage'
import i18n from '../../i18n/i18n'
import { getTooltips } from '../../reducers/modals/selectors/getModals'
import { ModalActions } from '../../reducers/modals/actionNames'
import { Mixpanel } from '../../utils/Mixpanel'
import SpinningIcon from '../../components/Template/SpinningIcon'

function EmployeeForm({ history, ...rest }: any) {
  const size = useSize()
  const isDesktop = is.desktop()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [phone, setPhone] = React.useState('')
  const [closeModalOpen, setCloseModalOpen] = React.useState(false)
  const toggleCloseModal = () => {
    setCloseModalOpen(!closeModalOpen)
  }
  const [pathname, setPathname] = useState('')
  const emailError = useSelector(getEmailError)
  const loading = useSelector(getEmployeeLoading)
  const tooltips = useSelector(getTooltips)
  const [stopBlocking, setStopBlocking] = useState(false)
  const [phoneError, setPhoneError] = React.useState(false)

  useEffect(() => {
    dispatch({ type: EmployeesAction.SetEmailError, payload: '' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (rest.initialValues) {
      Mixpanel.track('Employees List Edit Employee Screen View', {})
    } else {
      Mixpanel.track('Employees List Add Employee Screen View', {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const values: any = useSelector(getFormValues('employeeForm')) || {}

  const unblock = history.block((tx, action) => {
    if (stopBlocking) {
      unblock()
      return true
    }

    if (tx.pathname.includes('/login')) {
      unblock()
      dispatch({ type: ModalActions.CloseTooltips })
      return true
    }

    if ((rest as any).dirty) {
      if (
        driver.getItem(
          names.UserAccountStorage.DontShowAgainCloseModalEmployee,
          '0',
        ) === '1'
      ) {
        dispatch({ type: ModalActions.CloseTooltips })
        if (action === 'POP') {
          dispatch({ type: EmployeesAction.SetTab, payload: 0 })
          unblock()
          return false
        }

        unblock()
        return true
      } else {
        if (tx.pathname.includes('/employees')) {
          unblock()
          dispatch({ type: ModalActions.CloseTooltips })
          return true
        }

        if (action === 'PUSH') {
          setPathname(tx.pathname)
        }
        setCloseModalOpen(true)
        return false
      }
    } else {
      if (action === 'POP') {
        dispatch({ type: EmployeesAction.SetTab, payload: 0 })
        unblock()
        return false
      }
    }

    dispatch({ type: ModalActions.CloseTooltips })
    unblock()
    return true
  })

  useEffect(() => {
    setStopBlocking(false)
    setPhone(values.phone)
    setPathname('')
    return () => {
      if (unblock) {
        unblock()
      }
      dispatch({ type: EmployeesAction.SetTab, payload: 0 })
      dispatch({ type: ModalActions.CloseTooltips })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const verifyPhone = type => cb => {
    if (isEmpty(phone) || !/^[\d +]*$/g.test(phone)) {
      setPhoneError(true)
    } else {
      if (cb && typeof cb === 'function') {
        cb()

        if (type === 'call') {
          Mixpanel.track('Employees List  Make A Phone Call', {
            'Employee ID': rest.initialValues
              ? rest.initialValues.id
              : undefined,
          })
        } else {
          Mixpanel.track('Employees List Send A SMS', {
            'Employee ID': rest.initialValues
              ? rest.initialValues.id
              : undefined,
          })
        }
      }
    }
  }

  const changePhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value)
  }

  const changeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: EmployeesAction.SetEmailError, payload: '' })
  }

  const modalOpen = (id, element) => () => {
    dispatch(openModal(id, element))
  }

  const normalizeEmail = val => {
    return val.replace(/\s+/g, '')
  }

  const normalizePhone = (val, prev) => {
    return /^[\d +]*$/g.test(val) ? val.substr(0, 25) : prev
  }

  function onSubmit() {
    dispatch({ type: EmployeesAction.SetEmployeeLoading, payload: true })
    setStopBlocking(true)
    if (unblock) {
      unblock()
    }
    dispatch(stopAsyncValidation('employeeForm', {}))
    setTimeout(() => {
      dispatch({ type: ModalActions.CloseTooltips })
      dispatch(submit('employeeForm'))
    }, 500)
  }

  const toggleTooltip = id => () => {
    if (tooltips.includes(id)) {
      dispatch(closeTooltip(id))
    } else {
      dispatch({ type: ModalActions.CloseTooltips })
      dispatch(openTooltip(id))
    }
  }

  function closeForm() {
    if ((rest as any).dirty) {
      if (
        driver.getItem(
          names.UserAccountStorage.DontShowAgainCloseModalEmployee,
          '0',
        ) === '1'
      ) {
        if (rest.initialValues) {
          Mixpanel.track('Employees List Edit Employee Abandoned', {
            'Employee ID': rest.initialValues.id,
          })
        } else {
          Mixpanel.track('Employee List New Employee Abandoned', {})
        }

        if (unblock) {
          unblock()
        }
        dispatch({ type: EmployeesAction.SetTab, payload: 0 })
        dispatch({ type: ModalActions.CloseTooltips })
        return
      }

      setCloseModalOpen(true)
    } else {
      if (rest.initialValues) {
        Mixpanel.track('Employees List Edit Employee Abandoned', {
          'Employee ID': rest.initialValues.id,
        })
      } else {
        Mixpanel.track('Employee List New Employee Abandoned', {})
      }

      if (unblock) {
        unblock()
      }
      dispatch({ type: EmployeesAction.SetTab, payload: 0 })
      dispatch({ type: ModalActions.CloseTooltips })
    }
  }

  const onClose = () => {
    if (rest.initialValues) {
      Mixpanel.track('Employees List Edit Employee Abandoned', {
        'Employee ID': rest.initialValues.id,
      })
    } else {
      Mixpanel.track('Employee List New Employee Abandoned', {})
    }
    if (unblock) {
      unblock()
    }
    dispatch({ type: EmployeesAction.SetTab, payload: 0 })
    if (pathname && !pathname.includes('/employees')) {
      history.push(pathname)
    }
  }

  const changeScopeGroup = () => {
    dispatch(change('employeeForm', 'scope_block', true))
  }

  useEffect(() => {
    return () => {
      if (unblock) {
        unblock()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const tooltipedLabel = (label, tooltip, space = true) => {
    return (
      <div
        key={isDesktop ? label : label + '-mobile'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: space ? 'space-between' : 'unset',
        }}
      >
        <span>{t(label)}</span>
        <Tooltip
          placement={'top'}
          title={t(tooltip)}
          onClick={!isDesktop ? toggleTooltip(tooltip) : undefined}
          viewportBoundary={true}
          disablePropagation={true}
          disableHoverListener={isDesktop ? undefined : true}
          tooltipId={tooltip}
        >
          <FiInfo style={{ marginLeft: '10px' }} />
        </Tooltip>
      </div>
    )
  }

  return (
    <Form onSubmit={null} row={true}>
      <CloseModal
        open={closeModalOpen}
        close={toggleCloseModal}
        closeModal={onClose}
        employee={rest.initialValues ? rest.initialValues.id : undefined}
      />
      <Desktop>
        <ButtonsWrapper isDesktop={isDesktop}>
          <SubmitButton
            size={size}
            className={'settings-button-submit'}
            type="button"
            style={{ marginRight: '10px' }}
            onClick={closeForm}
            cancel={true}
          >
            <Trans i18nKey={'cancel'} />
          </SubmitButton>
          <SubmitButton
            size={size}
            className={'settings-button-submit'}
            type="button"
            onClick={onSubmit}
          >
            {loading ? (
              <SpinningIcon />
            ) : (
              <>
                <FiSave />
                <Trans i18nKey={'save'} />
              </>
            )}
          </SubmitButton>
        </ButtonsWrapper>
      </Desktop>

      {!isDesktop && (
        <Title
          style={{
            fontSize: `${16 * size}px`,
          }}
          size={size}
        >
          {values.name && values.surname
            ? `${values.name} ${values.surname}`
            : t('BED_3610_user_1')}
        </Title>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isDesktop ? '1fr 1fr' : '1fr',
          columnGap: '50px',
          overflowY: isDesktop ? 'unset' : 'auto',
          maxHeight: isDesktop ? 'unset' : 'calc(100vh - 200px)',
          width: '100%',
          paddingRight: !isDesktop ? '18px' : '0px',
          paddingBottom: !isDesktop ? '70px' : '0px',
        }}
      >
        <FormGroup.Render
          column={true}
          size={size}
          withoutTitle={!isDesktop}
          title={
            values.name && values.surname
              ? `${values.name} ${values.surname}`
              : t('BED_3610_user_1')
          }
        >
          <TextInput.ReduxField
            size={size}
            autocomplete={'off'}
            name={`name`}
            label={t('BED_3610_name')}
            isSmallReservation={true}
            width={'100%'}
          />

          <TextInput.ReduxField
            size={size}
            autocomplete={'off'}
            name={`surname`}
            label={t('BED_3610_surname')}
            isSmallReservation={true}
            width={'100%'}
          />

          <Flex alignStart style={{ width: '100%' }} row={true}>
            <TextInput.ReduxField
              label={t('email')}
              size={size}
              width={'100%'}
              name={`email`}
              errorMsg={emailError ? (t(emailError) as any) : undefined}
              normalize={normalizeEmail}
              onChange={changeEmail}
              isSmallReservation={true}
              style={{
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
            />
            <Flex style={{ marginTop: `${34 * size}px` }}>
              <TemplateSendButton
                employee={rest.initialValues ? rest.initialValues.id : 0}
                size={size}
                event={{
                  guest: {
                    email: values.email,
                  },
                }}
                modalOpen={modalOpen}
              />
            </Flex>
          </Flex>
          <Flex alignStart style={{ width: '100%' }} row={true}>
            <TextInput.ReduxField
              size={size}
              label={t('reservation_phone')}
              width={'100%'}
              name={`phone`}
              normalize={normalizePhone}
              onChange={changePhone}
              errorMsg={
                phoneError
                  ? (t('reservation_dialing_number_parse_error') as any)
                  : undefined
              }
              type={'text'}
              isSmallReservation={true}
              style={{
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
            />
            <Flex style={{ marginTop: `${34 * size}px` }}>
              <CallButton
                event={{
                  guest: {
                    phone: values.phone,
                  },
                }}
                size={size}
                disableEvent={true}
                onClick={verifyPhone('call')}
              />
            </Flex>
            <Flex style={{ marginTop: `${34 * size}px` }}>
              <MessageSendButton
                event={{
                  guest: {
                    phone: values.phone,
                  },
                }}
                employee={rest.initialValues ? rest.initialValues.id : 0}
                size={size}
                disableEvent={true}
                onClick={verifyPhone('sms')}
                modalOpen={modalOpen}
              />
            </Flex>
          </Flex>

          <Select.ReduxField
            size={size}
            closeMenuOnScroll={true}
            isSmallReservation={true}
            name={'scope_group'}
            menuPlacement={'auto'}
            onChange={changeScopeGroup}
            label={tooltipedLabel(
              'BED_3610_permission_pattern',
              'BED_3610_permission_pattern_tooltip',
              false,
            )}
            menuPosition={'fixed'}
            width={'100%'}
            menuPortalTarget={document.body}
            zIndex={2000}
            placeholder={t('select')}
            className={'employee-scope-group'}
            data-cy={'employee-scope-group'}
          >
            <Select.Option
              data-cy={'employee-scope-group-admin'}
              value={ScopeGroup.Admin}
            >
              {t('BED_3610_administrator')}
            </Select.Option>
            <Select.Option
              data-cy={'employee-scope-group-cs'}
              value={ScopeGroup.Cleaning}
            >
              {t('BED_3610_cleaning_staff')}
            </Select.Option>
            <Select.Option
              data-cy={'employee-scope-group-i'}
              value={ScopeGroup.Investor}
            >
              {t('BED_3610_investor')}
            </Select.Option>
            <Select.Option
              data-cy={'employee-scope-group-r'}
              value={ScopeGroup.Reception}
            >
              {t('BED_3610_reception')}
            </Select.Option>
            <Select.Option
              data-cy={'employee-scope-group-fa'}
              value={ScopeGroup.Full}
            >
              {t('BED_5712_full_access')}
            </Select.Option>
            <Select.Option
              data-cy={'employee-scope-group-own'}
              value={ScopeGroup.Own}
            >
              {t('BED_3610_own')}
            </Select.Option>
          </Select.ReduxField>

          <TextareaInput.ReduxField
            size={size}
            name={'notes'}
            isSmallReservation={true}
            label={t('reservation_note')}
            maxLength={150}
            width={'100%'}
            rows={4}
            style={{ resize: 'none' }}
          />
        </FormGroup.Render>

        <FormGroup.Render
          size={size}
          column={true}
          title={t('BED_3610_permission_management')}
        >
          {isDesktop ? (
            <>
              <Scrollbars
                autoHeight={true}
                renderTrackHorizontal={Null}
                renderThumbHorizontal={Null}
                autoHeightMax={
                  isDesktop ? 'calc(100vh - 200px)' : 'calc(100vh - 278px)'
                }
              >
                {PermissionList.map(p => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingRight: '20px',
                    }}
                  >
                    <Checkbox.ReduxField
                      size={size}
                      fireEventOnClick={true}
                      wrapperStyle={isDesktop ? {} : { width: 'fit-content' }}
                      name={'scope.' + p.scope}
                      key={p.scope}
                      label={t(p.label)}
                      isSmallReservation={true}
                    />
                    <Tooltip
                      placement={'top'}
                      title={t(p.tooltip)}
                      viewportBoundary={true}
                      disablePropagation={true}
                    >
                      <FiInfo style={{ marginLeft: '10px' }} />
                    </Tooltip>
                  </div>
                ))}
              </Scrollbars>
            </>
          ) : (
            <>
              {PermissionList.map(p => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Checkbox.ReduxField
                    size={size}
                    fireEventOnClick={true}
                    wrapperStyle={isDesktop ? {} : { width: 'fit-content' }}
                    name={'scope.' + p.scope}
                    key={p.scope}
                    label={t(p.label)}
                    isSmallReservation={true}
                  />
                  <Tooltip
                    placement={'top'}
                    title={t(p.tooltip)}
                    onClick={!isDesktop ? toggleTooltip(p.tooltip) : undefined}
                    viewportBoundary={true}
                    disablePropagation={true}
                    disableHoverListener={!isDesktop}
                    tooltipId={p.tooltip}
                  >
                    <FiInfo style={{ marginLeft: '10px' }} />
                  </Tooltip>
                </div>
              ))}
            </>
          )}
        </FormGroup.Render>
        {!isDesktop && (
          <ButtonWrapper1>
            <Button
              onClick={closeForm}
              style={{ width: '100%', marginRight: '12px' }}
              size={size}
              light={true}
              type={'button'}
            >
              {t('cancel')}
            </Button>
            <Button
              onClick={onSubmit}
              style={{ width: '100%', marginLeft: '12px' }}
              size={size}
              primary={true}
              type={'button'}
            >
              {t('save')}
            </Button>
          </ButtonWrapper1>
        )}
      </div>
    </Form>
  )
}

const ButtonWrapper1 = styled.div`
  position: absolute;
  bottom: 0px;
  width: calc(100% - 40px);
  padding: 20px 0px;
  border-radius: 8px;
  height: 78px;
  background-color: white;
  display: flex;
  justify-content: center;
`

const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    )
}

export default withRouter(reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: true,
  form: 'employeeForm',
  onSubmit: (values, dispatch, props) => {
    dispatch({ type: EmployeesAction.AddOrUpdateEmployee, payload: values })
  },
  shouldAsyncValidate,
  asyncValidate(values: any, dispatch) {
    return new Promise((resolve, reject) => {
      const errors: any = {}
      if (!values.name) {
        errors.name = 'BED_3610_field_not_empty'
        dispatch(fireToastError(i18n.t('BED_3610_name_not_empty')))
      }
      if (!values.surname) {
        errors.surname = 'BED_3610_field_not_empty'
        dispatch(fireToastError(i18n.t('BED_3610_surname_not_empty')))
      }
      if (!values.email) {
        errors.email = 'BED_3610_field_not_empty'
        dispatch({
          type: EmployeesAction.SetEmailError,
          payload: 'BED_3610_field_not_empty',
        })
        dispatch(fireToastError(i18n.t('BED_3610_email_not_empty')))
      }

      if (values.email && !validateEmail(values.email)) {
        errors.email = 'reg_error_email_not_email'
        dispatch({
          type: EmployeesAction.SetEmailError,
          payload: 'reg_error_email_not_email',
        })
      }

      if (isEmpty(errors)) {
        return resolve({} as any)
      }
      dispatch({ type: EmployeesAction.SetEmployeeLoading, payload: false })
      return reject(errors)
    })
  },
  onChange(
    values: any,
    dispatch: Dispatch<any>,
    props: any,
    previousValues: any,
  ) {
    if (
      (!props.initialValues ||
        !(values.scope_group && !previousValues.scope_group)) &&
      values.scope_group !== previousValues.scope_group
    ) {
      if (!values.scope_group_block) {
        dispatch(
          change(
            'employeeForm',
            'scope',
            ScopeGroupPermissions[values.scope_group],
          ),
        )
      }
    }

    dispatch(change('employeeForm', 'scope_group_block', false))

    if (
      (!previousValues.scope ||
        (previousValues.scope &&
          !previousValues.scope.SCOPE_CAN_EDIT_RESERVATIONS)) &&
      (values.scope && values.scope.SCOPE_CAN_EDIT_RESERVATIONS)
    ) {
      dispatch(
        change('employeeForm', 'scope.SCOPE_CAN_VIEW_RESERVATIONS', true),
      )
    }

    if (
      (!previousValues.scope ||
        (previousValues.scope &&
          !previousValues.scope.SCOPE_CAN_EDIT_RESERVATIONS)) &&
      (values.scope && values.scope.SCOPE_CAN_EDIT_RESERVATIONS)
    ) {
      dispatch(change('employeeForm', 'scope.SCOPE_HIDE_CLIENT_DATA', true))
    }

    if (
      (!previousValues.scope ||
        (previousValues.scope &&
          !previousValues.scope.SCOPE_CAN_EDIT_RESERVATIONS)) &&
      (values.scope && values.scope.SCOPE_CAN_EDIT_RESERVATIONS)
    ) {
      dispatch(change('employeeForm', 'scope.SCOPE_CAN_USE_INVOICES', true))
    }

    if (
      previousValues.scope &&
      previousValues.scope.SCOPE_CAN_VIEW_RESERVATIONS &&
      (values.scope && !values.scope.SCOPE_CAN_VIEW_RESERVATIONS)
    ) {
      dispatch(
        change('employeeForm', 'scope.SCOPE_CAN_EDIT_RESERVATIONS', false),
      )
    }

    if (
      previousValues.scope &&
      previousValues.scope.SCOPE_HIDE_CLIENT_DATA &&
      (values.scope && !values.scope.SCOPE_HIDE_CLIENT_DATA)
    ) {
      dispatch(
        change('employeeForm', 'scope.SCOPE_CAN_EDIT_RESERVATIONS', false),
      )
    }

    if (
      (!previousValues.scope ||
        (previousValues.scope &&
          !previousValues.scope.SCOPE_CAN_USE_LIST_CLIENTS)) &&
      (values.scope && values.scope.SCOPE_CAN_USE_LIST_CLIENTS)
    ) {
      dispatch(change('employeeForm', 'scope.SCOPE_HIDE_CLIENT_DATA', true))
    }

    if (
      props.initialValues &&
      !isEmpty(previousValues) &&
      !isEqual(values.scope, previousValues.scope)
    ) {
      if (values.scope_block) {
        return dispatch(change('employeeForm', 'scope_block', false))
      }
      dispatch(change('employeeForm', 'scope_group_block', true))
      dispatch(change('employeeForm', 'scope_group', ScopeGroup.Own))
    }

    if (
      previousValues.scope &&
      previousValues.scope.SCOPE_HIDE_CLIENT_DATA &&
      (values.scope && !values.scope.SCOPE_HIDE_CLIENT_DATA)
    ) {
      dispatch(
        change('employeeForm', 'scope.SCOPE_CAN_USE_LIST_CLIENTS', false),
      )
    }
  },
})(EmployeeForm) as any) as any
